export default __webpack_public_path__ + "static/media/chart-dark.7d788c13.png";